import React, {useEffect, useState} from 'react';
import {
    Box,
    Grid,
    Popover,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tabs,
    TextField
} from "@mui/material";
import {useTranslation} from "react-i18next";
import Tab from "@mui/material/Tab";
import Button from "@mui/material/Button";
import {FileCard, PopupContract, TableTabLegalClient} from "../index";
import {useDispatch, useSelector} from "react-redux";
import {getOnePerson} from "../../redux/actions/client/personActions";
import {getOneLegalClient} from "../../redux/actions/client/legalClientActions";
import moment from "moment";
import 'moment/locale/ru'
import TableTabPerson from "./TableTabPerson";
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import TableTabSigners from "./TableTabSigners";
import PopupContractComment from "./PopupContractComment";
import {changeContractState} from "../../redux/actions/contract/contractActions";
import {checkRoles} from "../../functions/checkRoles";
// NCALayer подключается лениво — только при проверке валидности
import {contractRequestCRUD, contractSignerCRUD} from "../../http/CRUD";
import {LoadingButton} from "@mui/lab";
import useLoader from "../../hooks/useLoader";
import {showSuccessSnackbar} from "../../redux/actions/userActions";
import Typography from "@mui/material/Typography";
import {useHistory, useLocation} from "react-router-dom";
import { CONTRACT_REQUESTS_ROUTE} from "../../routes/const";
import {$authHost} from "../../http";

window.Buffer = window.Buffer || require("buffer").Buffer;

moment.locale('ru')

function TableTab({rowsPage, locale, reload, reloadValue, contractData}) {

    const {t} = useTranslation();
    const location = useLocation()
    const [client, setClient] = useState([])
    const dispatch = useDispatch()
    const [contractRequest, setContractRequest] = useState([])
    const [value, setValue] = useState(0);
    const [open, setOpen] = useState(false)
    const [openComment, setOpenComment] = useState(false)
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        const tab = new URLSearchParams(location.search).get('tab')
        if (tab === 'signers' && (rowsPage?.typeId === 1 || rowsPage?.typeId === 2)) {
            setValue(6)
        }
    }, [location.search, rowsPage?.typeId])

    useEffect(() => {
        contractRequestCRUD.search(
            {
                paging: {skip: 0},
                filter: {
                    contractId: {
                        operand1: rowsPage?.number,
                        operator: "equals"
                    }
                }
            }
        ).then(({result}) => {
            setContractRequest(result)
        })
    }, [])

    // NCALayer подключение — ленивое (только при проверке валидности)
    const clientNCARef = React.useRef(null);

    const rowName = [
        {text: t("contractRequest.tableItemRequestObject.name")},
        {text: t("contractRequest.tableItemRequestObject.district")},
        {text: t("contractRequest.tableItemRequestObject.city")},
        {text: t("contractRequest.tableItemRequestObject.locality")},
        {text: t("contractRequest.tableItemRequestObject.address")},
        {text: t("contractRequest.tableItem.actions")},
    ]

    const rowName2 = [
        {text: t("specification.tableItem.service")},
        {text: t("specification.tableItem.unitOfMeasure")},
        {text: t("specification.tableItem.qty")},
        {text: t("specification.tableItem.price")},
        {text: t("specification.tableItem.anObject")},
        {text: t("specification.tableItem.servicesSchedule")},
        {text: t("specification.tableItem.actions")},
    ]

    const rowName3 = [
        {text: t("contract.tableItemSchedule.targetMonth")},
        {text: t("contract.tableItemSchedule.targetYear")},
        {text: t("contractRequest.tableItem.actions")},
    ]

    const handleClose = () => {
        setOpen(false)
    }
    const handleCloseComment = () => {
        setOpenComment(false)
    }


    const isAdmin = checkRoles("SuperAdministrator", "Administrator")
    const {loading, start, stop} = useLoader(false);

    const {profile} = useSelector((state) => state.profile);

    const showConformButton = React.useMemo(() => {
        if (rowsPage.status !== 'На согласовании') return false
        if (isAdmin) {
            return rowsPage.signers?.some((el) => el.isSigned !== true)
        }
        return rowsPage.signers?.some(
            (el) =>
                (el?.employee?.userId === profile?.userId || el?.userId === profile?.userId) &&
                el.isSigned !== true
        )
    }, [rowsPage.status, rowsPage.signers, isAdmin, profile?.userId])

    useEffect(() => {
        (async function () {
            const personId = rowsPage?.client?.personId
            const legalPersonId = rowsPage?.client?.legalPersonId
            if (personId) {
                const data = await dispatch(getOnePerson(personId))
                setClient({...data, typeClient: 1})
            } else if (legalPersonId) {
                const data = await dispatch(getOneLegalClient(legalPersonId))
                setClient({...data, typeClient: 2})
            }
        }())
    }, [dispatch, rowsPage]);

    // Используем данные, переданные из ContractView, вместо повторного запроса
    const [oneContract, setOneContract] = useState(contractData || [])

    useEffect(() => {
        if (contractData) {
            setOneContract(contractData)
        }
    }, [contractData])

    const handleCheckContract = async () => {
        if (lastElement) {
            start()
            try {
                // Ленивое подключение к NCALayer — только при нажатии кнопки
                if (!clientNCARef.current) {
                    const { ncaLayer } = await import('../../hooks/ecp/NCALayerClient');
                    const instance = new ncaLayer();
                    instance.onmessage = function (msg) {
                        if (msg?.result === true) {
                            dispatch(showSuccessSnackbar("Договор валидный", "success"))
                        }
                    };
                    clientNCARef.current = instance;
                    // Ждём подключения WebSocket
                    await new Promise((resolve, reject) => {
                        const ws = instance.webSocket;
                        if (ws.readyState === WebSocket.OPEN) { resolve(); return; }
                        ws.addEventListener('open', resolve, { once: true });
                        ws.addEventListener('error', () => reject(new Error('NCALayer не запущен')), { once: true });
                        setTimeout(() => reject(new Error('Таймаут подключения к NCALayer')), 5000);
                    });
                }
                const data = await contractSignerCRUD.get(lastElement.id)
                const jsonData = JSON.parse(data?.sign);
                clientNCARef.current.verifyXml(jsonData?.SignedXml)
            } catch (e) {
                dispatch(showSuccessSnackbar(e.message || "Ошибка подключения к NCALayer", "error"))
            }
            stop()
        }
    }

    const {push} = useHistory()

    const lastSigned = React.useMemo(() => {
        return oneContract?.signers?.find(el => el.lastSigned) || null
    }, [oneContract?.signers])

    const lastElement = React.useMemo(() => {
        return oneContract?.signers?.slice(-1)[0] || null
    }, [oneContract?.signers])

    // Фильтрация дубликатов спецификаций по ID и комбинации ключевых полей
    const uniqueSpecifications = React.useMemo(() => {
        if (!oneContract?.specifications?.length) return [];
        const seenById = new Set();
        const seenByKey = new Set();
        
        return oneContract.specifications.filter(spec => {
            // Проверка по ID
            if (spec.id && seenById.has(spec.id)) {
                return false;
            }
            if (spec.id) {
                seenById.add(spec.id);
            }
            
            // Проверка по комбинации ключевых полей для случаев, когда ID могут быть разными, но данные одинаковые
            const key = `${spec.serviceId || ''}_${spec.objectId || ''}_${spec.scheduleId || ''}_${spec.unitId || ''}_${spec.price || ''}_${spec.quantity || ''}`;
            if (seenByKey.has(key)) {
                return false;
            }
            seenByKey.add(key);
            
            return true;
        });
    }, [oneContract?.specifications]);

    const handleRecreationContract = async () => {
        await dispatch(changeContractState(rowsPage?.number, 7, 1))
        reload()
    }

    const handleTerminateContract = async () => {
        await dispatch(changeContractState(rowsPage?.number, 4, 8, comment))
        reload()
        await dispatch(showSuccessSnackbar("Договор расторгнут", "success"))
    }

    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClosePopover = () => {
        setAnchorEl(null);
    };

    const openPopover = Boolean(anchorEl);
    const idPopover = open ? 'simple-popover' : undefined;

    const [comment, setComment] = useState('')

    return (
        <Box sx={{padding: '0 20px'}}>
            <Tabs
                value={value}
                onChange={handleChange}
            >
                <Tab label="Основная информация"/>
                <Tab label="Клиент"/>
                <Tab label="Договор"/>
                <Tab label="Объекты"/>
                <Tab label="Услуги"/>
                <Tab label="График исследований"/>
                {(rowsPage?.typeId === 1 || rowsPage?.typeId === 2) && <Tab label="Согласующие"/>}
            </Tabs>
            {value === 0 && <>
                {Object.keys(rowsPage).slice(0, 8).map((el, idx) => (
                    <Grid container key={idx}>
                        <Grid item xs={6}>
                            <Box sx={{
                                padding: '5px 0',
                                borderTop: "1 px",
                                borderBottom: '1px'
                            }}>{t(`${locale}.tableItem.${[el]}`)}</Box>
                        </Grid>
                        <Grid item xs={6}>
                            <Box sx={{
                                padding: '5px 0',
                                borderTop: "1 px",
                                borderBottom: '1px'
                            }}>{rowsPage[el] ? rowsPage[el] : 'Значение не задано'}</Box>
                        </Grid>
                    </Grid>
                ))}
                <Box mt={2} mb={2}>
                    <Typography gutterBottom variant={'h6'}>Сводные заявки:</Typography>
                    <table>
                        {contractRequest?.length ? contractRequest.map(_ => <tr>
                            <td onClick={() => {
                                console.log(_)
                                push(CONTRACT_REQUESTS_ROUTE + `/${_.id}`)
                            }}>{_.number}</td>
                        </tr>) : 'Отсутствуют'}
                    </table>
                </Box>

                {showConformButton && <Button onClick={() => setOpenComment(true)}
                                    sx={{margin: '10px 0 10px 10px'}} color="success" variant="outlined"
                                    startIcon={<CompareArrowsIcon/>}>
                    Согласовать
                </Button>}
                {rowsPage.status === 'Подписан' && <Button
                    sx={{margin: '10px 0 10px 10px'}} color="warning" variant="outlined">
                    Отправить в бухгалтерию
                </Button>}
                {rowsPage.status === 'Подписан' && <LoadingButton loading={loading} onClick={handleCheckContract}
                                                                  sx={{margin: '10px 0 10px 10px'}} color="info"
                                                                  variant="outlined">
                    Проверить валидность договора
                </LoadingButton>}
                {rowsPage.status === 'Подписан' && <LoadingButton loading={loading} onClick={handleClick}
                                                                  sx={{margin: '10px 0 10px 10px'}} color="error"
                                                                  variant="outlined">
                    Расторгнуть
                </LoadingButton>}
                <Popover
                    id={idPopover}
                    open={openPopover}
                    anchorEl={anchorEl}
                    onClose={handleClosePopover}
                    anchorOrigin={{
                        vertical: 'center',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'center',
                        horizontal: 'center',
                    }}
                >
                    <Stack direction="column" spacing={2} sx={{padding: 3, width: '350px'}}>
                        <TextField
                            multiline
                            label={"Комментарий"}
                            onChange={e => setComment(e.target.value)}
                            fullWidth
                            value={comment}
                        />
                        <Button onClick={handleTerminateContract} fullWidth variant="contained" sx={{mt: 3}}>
                            {'Подтвердить'}
                        </Button>
                    </Stack>
                </Popover>
                {rowsPage.status === 'Отказано' && <LoadingButton loading={loading} onClick={handleRecreationContract}
                                                                  sx={{margin: '10px 0 10px 10px'}} color="warning"
                                                                  variant="outlined">
                    Пересоздать
                </LoadingButton>}
            </>
            }
            {value === 1 && <>
                {client && client.typeClient === 1 ? <TableTabPerson client={client}/> : client.typeClient === 2 ?
                    <TableTabLegalClient client={client}/> : <Box>Клиент не указан</Box>}
            </>}
            {value === 2 && <>
                <Grid
                    container
                    sx={{marginTop: 1, marginBottom: 2}}
                    spacing={3}
                >
                    <Grid
                        item
                        lg={4}
                        md={4}
                        sm={6}
                        xs={12}
                    >
                        <FileCard handleOpen={setOpen} data={oneContract}/>
                    </Grid>
                </Grid>
            </>}
            {value === 3 && <>
                <Grid
                    container
                    sx={{marginTop: 1, marginBottom: 2}}
                    spacing={3}
                >
                    <Table>
                        <TableHead>
                            <TableRow>
                                {rowName.slice(0, -1).map((el, idx) => {
                                    return <TableCell key={idx}
                                                      align="center">{el.text}</TableCell>
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {oneContract?.objects.length ? oneContract.objects.map(el => (
                                <TableRow key={el.id}>
                                    <TableCell align="center">
                                        {el?.object?.name || 'Не заполнено'}
                                    </TableCell>
                                    <TableCell align="center">
                                        {el?.district?.name || 'Не заполнено'}
                                    </TableCell>
                                    <TableCell align="center">
                                        {el?.city?.name || 'Не заполнено'}
                                    </TableCell>
                                    <TableCell align="center">
                                        {el?.locality?.name || 'Не заполнено'}
                                    </TableCell>
                                    <TableCell align="center">
                                        {el?.addressLine || 'Не заполнено'}
                                    </TableCell>
                                </TableRow>
                            )) : <TableCell colSpan={5}>Объектов нет</TableCell>}
                        </TableBody>
                    </Table>
                </Grid>
            </>}
            {value === 4 && <>
                <Grid
                    container
                    sx={{marginTop: 1, marginBottom: 2}}
                    spacing={3}
                >
                    <Table>
                        <TableHead>
                            <TableRow>
                                {rowName2.slice(0, -1).map((el, idx) => {
                                    return <TableCell key={idx}
                                                      align="center">{el.text}</TableCell>
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {uniqueSpecifications?.length ? uniqueSpecifications.map(el => (
                                <TableRow key={el.id}>
                                    <TableCell align="center">
                                        {el?.service?.name || 'Не заполнено'}
                                    </TableCell>
                                    <TableCell align="center">
                                        {el?.unit?.name || 'Не заполнено'}
                                    </TableCell>
                                    <TableCell align="center">
                                        {el?.quantity || 'Не заполнено'}
                                    </TableCell>
                                    <TableCell align="center">
                                        {el?.price || 'Не заполнено'}
                                    </TableCell>
                                    <TableCell align="center">
                                        {el?.object?.name || 'Не заполнено'}
                                    </TableCell>
                                    <TableCell align="center">
                                        {el?.schedule?.name || 'Не заполнено'}
                                    </TableCell>
                                </TableRow>
                            )) : <TableCell colSpan={5}>Услуги не заполнены</TableCell>}
                        </TableBody>
                    </Table>
                </Grid>
            </>}
            {value === 5 && <>
                <Grid
                    container
                    sx={{marginTop: 1, marginBottom: 2}}
                    spacing={3}
                >
                    <Table>
                        <TableHead>
                            <TableRow>
                                {rowName3.slice(0, -1).map((el, idx) => {
                                    return <TableCell key={idx}
                                                      align="center">{el.text}</TableCell>
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {oneContract?.schedules?.length ? oneContract?.schedules.map(el => (
                                <TableRow key={el.id}>
                                    <TableCell align="center">
                                        {moment(el?.targetMonth).format('MMMM') || 'Не заполнено'}
                                    </TableCell>
                                    <TableCell align="center">
                                        {moment(el?.targetYear).format('YYYY') || 'Не заполнено'}
                                    </TableCell>
                                </TableRow>
                            )) : <TableCell colSpan={5}>График не заполнен</TableCell>}
                        </TableBody>
                    </Table>
                </Grid>
            </>}
            {(rowsPage?.typeId === 1 || rowsPage?.typeId === 2) && value === 6 &&
                <TableTabSigners reloadValue={reloadValue} reload={reload} number={rowsPage?.number}
                                 status={rowsPage?.status} signers={rowsPage?.signers} client={rowsPage?.client}/>}
            <PopupContract lastSigned={lastSigned} rowsPage={rowsPage} typeId={rowsPage?.typeId} id={rowsPage?.number}
                           open={open}
                           handleClose={handleClose}/>
            <PopupContractComment lastSigned={lastSigned} data={oneContract} reload={reload}
                                  id={rowsPage?.number}
                                  open={openComment} handleClose={handleCloseComment}/>
        </Box>
    )
}

export default TableTab;
